import styled, {css, DefaultTheme, FlattenInterpolation, keyframes, ThemeProps} from 'styled-components';

export type SimpleSpinnerLoaderVariant = 'simple' | 'pieBig' | 'blackLarge' | 'blackSmall' | 'whiteLarge' | 'whiteSmall';

const loadIconsAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const blackBaseCss = css`
  border: 2px solid ${({theme}) => theme.colors.charcoal80};
  border-top: 2px solid transparent;
`;

const whiteBaseCss = css`
  border: 2px solid ${({theme}) => theme.colors.surface};
  border-top: 2px solid transparent;
`;

const variantStyles: Record<SimpleSpinnerLoaderVariant, FlattenInterpolation<ThemeProps<DefaultTheme>>> = {
  pieBig: css`
    border-top: 4px solid rgba(243, 104, 5, 0.35);
    border-right: 4px solid rgba(243, 104, 5, 0.35);
    border-bottom: 4px solid rgba(243, 104, 5, 1);
    border-left: 4px solid rgba(243, 104, 5, 1);
    width: 32px;
    height: 32px;
  `,
  simple: css`
    border: 2px solid ${({theme}) => theme.colors.primaryText};
    border-top: 2px solid ${({theme}) => theme.colors.gray100};
    width: 20px;
    height: 20px;
    animation: ${loadIconsAnimation} 3s infinite ease-in-out;
  `,
  blackLarge: css`
    ${blackBaseCss}
    width: 20px;
    height: 20px;
  `,
  blackSmall: css`
    ${blackBaseCss}
    width: 16px;
    height: 16px;
  `,
  whiteLarge: css`
    ${whiteBaseCss}
    width: 20px;
    height: 20px;
  `,
  whiteSmall: css`
    ${whiteBaseCss}
    width: 16px;
    height: 16px;
  `,
};

const SimpleSpinnerLoader = styled.div<{variant?: SimpleSpinnerLoaderVariant}>`
  ${({variant}) => variantStyles[variant || 'simple']}
  border-radius: 50%;
  animation: ${loadIconsAnimation} 3s infinite linear;
`;

export default SimpleSpinnerLoader;
